import React, { useState, useEffect } from 'react'
// import { getActivities } from '../Context/prismic'
import { getEvent, updateSnapshot } from '../Context/firebase'
import { Timeline, Steps, Loader } from 'rsuite'
import {
  Container, FlexH, TitleDiv, EventState, H1, BodyDiv,
  DescriptionDiv, MyStepItem, MyTimelineItem
} from '../Components/Event/EventStyledComponents'

import Overview from '../Components/Event/Overview'
import Stepper from '../Components/Event/Stepper'
import { useParams } from 'react-router-dom'

const TimelineItem = (props) => {
  const {
    currentPhase, currentActivity, setCurrentActivity,
    setEventFinished, setCurrentStep, setOverview
  } = props
  const { event } = props
  const phase = event.phases[currentPhase]
  const onActivityClick = (e, index) => {
    e.stopPropagation()
    setCurrentActivity(index)
    setEventFinished(false)
    setOverview(true)
    setCurrentStep(0)
  }
  return (
    <Timeline>
      {event !== null &&
        phase.data.map((activity, index) => {
          return (
            <MyTimelineItem
              key={index}
              current={currentActivity === index ? 1 : 0}
              done={activity.isCompleted ? 1 : 0}
              onClick={e => onActivityClick(e, index)}
            >
              {!activity.topic ? activity.title[0].text : activity.topic}
            </MyTimelineItem>
          )
        }
        )}
    </Timeline>
  )
}

const EventPage = () => {
  const [isEventShared, setEventShared] = useState(false) // starts snapshot of the FB document
  const [isOverview, setOverview] = useState(true) // shows component before starting a new activity
  const [seconds, setSeconds] = useState(0) // seconds for the timer
  const [isTimerActive, setTimerActive] = useState(true) // minutes for the timer
  const [curPhase, setCurPhase] = useState(0) // current phase
  const [curActivity, setCurActivity] = useState(0) // current activity
  const [curStep, setCurStep] = useState(0) // current step
  const [isEventFinished, setEventFinished] = useState(false) // for now shows component after clicking 'Mark as completed' on the last activity
  const [loading, setLoading] = useState(true)
  const [event, setEvent] = useState(null)
  const { eventId } = useParams()
  const [hasInstructions, setHasInstructions] = useState(false)
  // const getActivitiesIds = event => event?.phases?.reduce((acc, el) => acc.concat(el.activities), [])
  useEffect(() => {
    shareEvent()
  }, [])

  const shareEvent = async () => {
    console.log(seconds)
    try {
      const event = await getEvent(eventId)
      if (!event) throw new Error('Event not found')
      setEvent({
        ...event,
        snapshot: ({
          currentPhase: 0,
          currentActivity: 0,
          currentStep: 0,
          overview: true,
          isEventFinished: false,
          seconds: 0,
          finished: ({}),
          timestamp: Date.now(),
          hasInstructions: hasInstructions
        })
      })
      setEventShared(true)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  useEffect(async () => {
    if (isEventShared && event) {
      const newSnapshot = {
        ...event.snapshot,
        currentPhase: curPhase,
        currentActivity: curActivity,
        currentStep: curStep,
        overview: isOverview,
        isEventFinished: isEventFinished,
        seconds: seconds,
        finished: event,
        timestamp: Date.now(),
        hasInstructions: hasInstructions
      }
      await updateSnapshot(eventId, newSnapshot)
    }
  }, [curPhase, curActivity, curStep, seconds,
    isOverview, isEventFinished, isEventShared, hasInstructions])

  // this is needed for normal data fetching if there's no SHARE event mode

  // useEffect(() => {
  //   const fetchEvent = async () => {
  //     try {
  //       const event = await getEvent(eventId)
  //       if (!event) throw new Error('Event not found')
  //       const allActivitieIds = getActivitiesIds(event)
  //       const activities = await getActivities(allActivitieIds)
  //       setEvent({
  //         ...event,
  //         phases: event?.phases?.map(phase => ({
  //           ...phase,
  //           activities: phase?.activities?.map(
  //             id => activities.find(a => a?.id === id)).map(el => Object.assign({}, el.data))
  //         }
  //         ))
  //       })
  //     } catch (err) {
  //       console.error(err)
  //     }
  //     setLoading(false)
  //   }
  //   fetchEvent()
  // }, [])

  // this is needed for normal data fetching if there's no SHARE event mode

  useEffect(() => {
    let interval = null
    if (!isOverview && isTimerActive) {
      interval = setInterval(() =>
        setSeconds(seconds => seconds + 1)
      , 1000)
    } else if (isOverview) {
      clearInterval(interval)
      setSeconds(0)
    }
    return () => clearInterval(interval)
  }, [isOverview, seconds, isTimerActive])

  const onPhaseClick = index => {
    setCurPhase(index)
    setEventFinished(false)
    setCurActivity(0)
    setCurStep(0)
    setOverview(true)
  }

  return (
    <Container>
      {loading
        ? <Loader backdrop size='lg' content='loading...' vertical />
        : <div>
          <TitleDiv>
            <H1>{event?.title}</H1>
            <FlexH>
              <EventState>{curPhase + 1}/{event?.phases?.length} phases</EventState>
              <EventState>{curActivity + 1}/{event?.phases[curPhase]?.activities?.length} activities</EventState>
            </FlexH>
          </TitleDiv>

          <BodyDiv>
            <div>
              <Steps current={0} vertical>
                {event?.phases !== null &&
                  event?.phases.map((phase, index) => (
                    <MyStepItem
                      title={phase?.name}
                      key={index}
                      current={curPhase === index ? 1 : 0}
                      done={phase?.isCompleted ? 1 : 0}
                      onClick={() => onPhaseClick(index)}
                      description={index === curPhase
                        ? <TimelineItem
                          currentPhase={curPhase}
                          setCurrentStep={setCurStep}
                          setOverview={setOverview}
                          currentActivity={curActivity}
                          setCurrentActivity={setCurActivity}
                          setEventFinished={setEventFinished}
                          event={event}
                        /> : ''}
                    />
                  ))}
              </Steps>
            </div>

            <div>
              <DescriptionDiv>
                <div style={{ padding: '30px 26px' }}>
                  {isOverview
                    ? <Overview
                      isEventFinished={isEventFinished}
                      setEventFinished={setEventFinished}
                      currentPhase={curPhase}
                      currentActivity={curActivity}
                      currentStep={curStep}
                      setCurrentStep={setCurStep}
                      setCurrentPhase={setCurPhase}
                      setCurrentActivity={setCurActivity}
                      phasesData={event}
                      phasesLength={event?.phases?.length - 1}
                      isOverview={isOverview}
                      setOverview={setOverview}
                      event={event}
                    />
                    : <Stepper
                      isEventFinished={isEventFinished}
                      setEventFinished={setEventFinished}
                      seconds={seconds}
                      isTimerActive={isTimerActive}
                      setTimerActive={setTimerActive}
                      currentPhase={curPhase}
                      currentActivity={curActivity}
                      currentStep={curStep}
                      setCurrentStep={setCurStep}
                      setCurrentPhase={setCurPhase}
                      setCurrentActivity={setCurActivity}
                      phasesData={event}
                      phasesLength={event?.phases?.length - 1}
                      isOverview={isOverview}
                      setOverview={setOverview}
                      event={event}
                      setEvent={setEvent}
                      hasInstructions={hasInstructions}
                      setHasInstructions={setHasInstructions}
                    />}
                </div>
              </DescriptionDiv>
            </div>

          </BodyDiv>
        </div>}
    </Container>
  )
}

export default EventPage
